import React from 'react';

import './page-header.scss';



const PageHeader = props => {
    return (
        <div className="page-header" style={{backgroundImage: `url(https://newspack-hipertextual.s3.amazonaws.com/wp-content/uploads/2014/03/posters-de-peliculas.jpg)`}}>
            <h2>{props.children}</h2>
        </div>
    );
}


export default PageHeader;
